export default {
  // Common
  NODE_JS: '>= 18',
  YARN: '>= 1.10.x',
  NPM: '>= 4.x',
  BUN: '>= 1.0.0',
  RUBY: '>= 2.6.10',
  JAVA: '>= 17 <= 20',
  // Android
  ANDROID_SDK: '>= 33.x',
  ANDROID_NDK: '>= 23.x',
  // iOS
  XCODE: '>= 12.x',
  COCOAPODS: '>= 1.10.0',
};
